<template>
    <div class="field-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="searchText" />
            <span class="material-icons"> search </span>
        </div>
        <div class="attribute-list">
            <div
                class="d-flex flex-column justify-content-center text-center align-items-center mb-5"
                v-if="!filterAttributes().length"
            >
                <div>
                    <span class="material-icons"> search </span>
                </div>
                <div>{{ $t("chatbotv2.noResultFound") }}</div>
            </div>
            <div class="attr-select">
                <div
                    text-color="lighter"
                    text-weight="semi-bold"
                    text-type="h5"
                    class="tpl-category-select-category-name"
                    v-if="filterAttributes('system').length"
                >
                    {{ $t("integrations.ticimaxMemberFields") }}
                </div>
                <div
                    data-checked="true"
                    data-index="0"
                    data-item-label="Name"
                    class="picker-item"
                    v-for="attr of filterAttributes('system')"
                    @click="pick(attr.value)"
                    :class="{ active: defaultSelected === attr.value }"
                >
                    <FieldIconPreview :attribute="attr.value" />

                    <span class="name">
                        {{ isLocalizedAttribute(attr.value) ? $t(`ticimax.attributes.${attr.value}`) : attr.value }}
                    </span>
                    <span class="description">
                        {{ attr.placeholder }}
                    </span>
                </div>
            </div>
            <hr />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import log2 from "../../../../../../../utils/log2";
import FieldIconPreview from "./FieldIconPreview.vue";
import TicimaxAttributes from "./TicimaxAttributes";

const log = log2("FieldPicker");
export default {
    name: "FieldPicker",
    components: { FieldIconPreview },
    props: {
        defaultSelected: {
            type: String,
            required: false,
        },
        pick: {
            type: Function,
            required: true,
        },
        filterMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
        types: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            searchText: "",
        };
    },
    computed: {
        ...mapGetters({}),
        ...mapState({}),
    },
    methods: {
        isLocalizedAttribute() {
            return true;
        },
        filterAttributes(type) {
            let allAttributes = TicimaxAttributes(this.types);

            let result = !!this.searchText
                ? allAttributes.filter((x) => this.searchText === "" || new RegExp(this.searchText, "gi").test(x.name))
                : allAttributes;

            result = result.filter((x) => _.isEmpty(type) || x.type === type);
            return result;
        },
    },
};
</script>

<style lang="scss">
.field-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .attribute-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 15px;
        margin: 0px 5px 0px 5px;
        gap: 10px;

        .attr-select {
            margin-bottom: 10px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 5px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons,
        .custom-attr-logo {
            color: #647283;
            font-size: 25px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 30px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
